<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import SliderModal from "./SliderModal.vue"
import SliderEditModal from "./SliderEditModal.vue"
import SlidersTable from "./SlidersTable.vue"

const title = "مدیریت اسلایدر ها"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت اسلایدر ها",
    active: true,
  },
])

const DEFAULT_SLIDER = {
  id: "",
  slider_title: "",
  slider_link: "",
  slider_priority: "",
  slider_image: "",
  status: "",
}

const sliderModel = ref({ ...DEFAULT_SLIDER })
const showSliderModal = ref(false)
const showSliderEditModal = ref(false)

const showAddNewModal = () => {
  showSliderModal.value = true
}

const showEditModal = () => {
  showSliderEditModal.value = true
}

function editSlider(slide) {
  store.dispatch("getSlider", slide.id).then(({ data }) => {
    sliderModel.value = data.data
    showEditModal()
  })
}

const onModalClose = () => {
  sliderModel.value = { ...DEFAULT_SLIDER }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="sliderList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست اسلایدر ها</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن اسلایدر
                    جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- sliders table  -->

          <SlidersTable @clickEdit="editSlider" />

          <!-- add and edit slider modal  -->

          <SliderModal
            v-model="showSliderModal"
            :slider="sliderModel"
            @close="onModalClose"
          />

          <SliderEditModal
            v-model="showSliderEditModal"
            :slider="sliderModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
